import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.ZCM_STORAGE],
  data() {
    return {
      logo: getPlanLogo(planTypes.ZCM_STORAGE),
      title: this.$t('billing.zcm_storage.title'),
      planType: planTypes.ZCM_STORAGE,
    };
  },

  created() {
    this.configDescription = this.$t('billing.zcm_storage.description', [this.basicConfig?.ZCMDefaultStorage || '10 GB'])
  }
};
